module.exports = __webpack_public_path__ + "img/pc3.c550d53f.png";